import React from 'react'
import { Link } from 'react-router'

import { cn } from '@/utils/cn'

interface KpiCardProps {
  label: string
  value: number | string
  sublabel?: string
  href?: string
  colorClass: string
  bgClass: string
  borderClass: string
}

export const KpiCard: React.FC<KpiCardProps> = ({
  label,
  value,
  sublabel,
  href,
  colorClass,
  bgClass,
  borderClass
}) => {
  const content = (
    <div
      className={cn(
        'rounded-lg border p-5 flex flex-col gap-1 transition-all duration-200',
        bgClass,
        borderClass,
        href && 'hover:shadow-md hover:scale-[1.02] cursor-pointer'
      )}
    >
      <p className={cn('text-3xl font-bold', colorClass)}>{value}</p>
      <p className="text-sm font-medium text-gray-700">{label}</p>
      {sublabel && <p className="text-xs text-gray-400">{sublabel}</p>}
    </div>
  )

  if (href) {
    return <Link to={href}>{content}</Link>
  }
  return content
}
